/**
 * Created by hernanherreros on 2019-05-27
 */

import * as React from 'react'
import styled from 'styled-components'
import LottieAnimation from '../../../components/Utils/LottieAnimation'
import animation from '../../../static/animations/clock.json'
import { color, ColorProps, fontSize, FontSizeProps, space, SpaceProps } from 'styled-system'
import { Trans } from '@lingui/macro'
import Button from '../../../components/Utils/Button'
import { Link } from 'react-router-dom'

interface Props {
  onReset: () => void;
  returnPath: string;
}

export default ({ returnPath, onReset }: Props) => (
  <Container>
    <Wrapper>
      <LottieAnimation animation={animation} height={200}/>
      <Text fontSize={3}><Trans>Su tiempo para inscribir ha terminado.</Trans></Text>
      <Text fontSize={2}><Trans>¿Desea tener 15 minutos más?</Trans></Text>

      <ButtonWrapper mt={5}>
        <Button color="primary" onClick={onReset}><Trans>Obtener 15 minutos más</Trans></Button>
        <LinkButton to={returnPath} mt={2} fontSize={1} color="primary">
          <Trans>Volver al inicio</Trans>
        </LinkButton>
      </ButtonWrapper>
    </Wrapper>
  </Container>
)

const Container = styled.div`
  height: 100%;
  width: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 30px 0;
`

const Wrapper = styled.div`
  max-width: 400px;
  width: 100%;
`
const Text = styled.h1<FontSizeProps>`
  font-weight: 400;
  color: #666;
  text-align: center;  
  
  ${fontSize}
`

const ButtonWrapper = styled.div<SpaceProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  
  ${space}
`

const LinkButton = styled(Link)<ColorProps & FontSizeProps & SpaceProps>`
  ${color}
  ${space}
  ${fontSize}
`